import React, { Component, useRef } from 'react';
import { ChatActions } from '../../components/ChatActions';
import { JqueryClassFaker } from '../../components/JqueryClassFaker';
import { Dashboard } from '../../components/Dashboard';
import useWavesEffect from "../hooks/useWavesEffect";
import { roomColorStyle } from 'functions/roomColors';
import { __, __n } from 'i18n/index';
import ChatHeaderSkeleton from 'react/chat/ChatHeaderSkeleton';

export default class ChatHeaderBar extends Component {
	constructor(props) {
		super(props);
		this.descriptionToggle = this.descriptionToggle.bind(this);
		this.toggleChatUserlistSidebar = this.toggleChatUserlistSidebar.bind(this);

		this.state = {
			bannerHovered: false,
			chatOptionsHovered: false,
		};

		this.bannerMouseEnter = this.bannerMouseEnter.bind(this);
		this.bannerMouseLeave = this.bannerMouseLeave.bind(this);
		this.chatOptionsMouseEnter = this.chatOptionsMouseEnter.bind(this);
		this.chatOptionsMouseLeave = this.chatOptionsMouseLeave.bind(this);
	}

	chatOptionsMouseEnter() {
		this.setState({
			chatOptionsHovered: true
		});
	}

	chatOptionsMouseLeave() {
		this.setState({
			chatOptionsHovered: false
		});
	}

	bannerMouseEnter() {
		this.setState({
			bannerHovered: true
		});
	}

	bannerMouseLeave() {
		this.setState({
			bannerHovered: false
		});
	}

	toggleChatUserlistSidebar() {
		const { toggleChatSidebar } = this.props;
		toggleChatSidebar();
	}

	descriptionToggle() {
		const { chatRoom } = this.props;
		chatRoom.descriptionToggle();
	}

	// The Chat view's room header: name (on phones, the rooms drawer button), then icon-over-label actions.
	// Rules, Pins (when the room has a pinned message), Admin (mods), People. Leaving is in the room menu.
	renderPageLayout() {
		const { chatRoom, toggleChatRules, peopleOpen, onTogglePeople, onOpenRooms } = this.props;
		const topic = chatRoom ? chatRoom.getTopic() : null;
		if((!chatRoom || !chatRoom.name) && !Dashboard.chatRoomsLoaded) {
			// Startup is still fetching the player's rooms (app/StartupEventManager).
			return <ChatHeaderSkeleton />;
		}
		return (
			<div
				className={`chat-header chat-header--page${chatRoom && chatRoom.colors ? ' chat-header--colored' : ''}`}
				style={roomColorStyle(chatRoom && chatRoom.colors)}
			>
				<h1 className='chat-header__title'>
					{onOpenRooms ? (
						// Phones: the room name opens the rooms drawer; the tab bar keeps the site menu.
						<button type='button' className='chat-header__rooms-button' onClick={onOpenRooms} aria-label={__('Rooms')}>
							<span className='chat-header__hash'>#</span>
							<span className='chat-header__name'>{chatRoom && chatRoom.name}</span>
							<i className='fa fa-angle-down chat-header__rooms-caret' aria-hidden='true' />
						</button>
					) : (
						<React.Fragment>
							<span className='chat-header__hash'>#</span>
							<span className='chat-header__name'>{chatRoom && chatRoom.name}</span>
						</React.Fragment>
					)}
				</h1>
				{topic &&
				<p className='chat-header__topic' title={topic}>{topic}</p>
				}
				<div className='chat-header__actions'>
					{chatRoom && chatRoom.has_ladder &&
					<ChatHeaderAction label={__('Rules')} icon='fa-book' onClick={toggleChatRules} />
					}
					{chatRoom && chatRoom.hasDescription() &&
					<ChatHeaderAction
						label={__('Pins')}
						icon='fa-thumb-tack'
						onClick={this.descriptionToggle}
						pressed={chatRoom.descriptionIsActive()}
					/>
					}
					{chatRoom && chatRoom.hasMod(myUser) &&
					// The room manager, with this room selected, in a new tab so the chat stays open.
					<ChatHeaderAction label={__('Admin')} icon='fa-gears' href={chatRoom.getEditUrl()} target='_blank' />
					}
					{onTogglePeople &&
					<ChatHeaderAction label={__('People')} icon='fa-users' onClick={onTogglePeople} pressed={!!peopleOpen} />
					}
				</div>
			</div>
		);
	}

	render() {
		const {
			chatSidebarToggle, chatRoom,
			aChatHasNewMentions,
			aChatHasUnreadMessages,
			bannerIsClickable, toggleMainChatMinimized, isPopup, isMinimized,
			toggleChatRules, showPersistentChatTabs, isPinned, pageLayout,
		} = this.props;
		if(pageLayout) {
			return this.renderPageLayout();
		}
		const { chatOptionsHovered, bannerHovered } = this.state;

		let bannerClick = undefined;
		let bannerNameClick = undefined;
		if(isMinimized) {
			bannerClick = toggleMainChatMinimized;
		} else {
			if(bannerIsClickable) {
				bannerNameClick = this.toggleChatUserlistSidebar;
			} else if(chatSidebarToggle) {
				bannerNameClick = chatSidebarToggle;
			}

			if(bannerHovered && !chatOptionsHovered && isPopup) {
				bannerClick = toggleMainChatMinimized;
			}
		}
		const classes = new JqueryClassFaker();
		classes.toggleClass('minimized', isMinimized);
		classes.toggleClass('banner_hovered', bannerHovered && !chatOptionsHovered);
		classes.toggleClass('has_new_messages', aChatHasUnreadMessages);
		return (
			<div
				onMouseEnter={this.bannerMouseEnter}
				onMouseLeave={this.bannerMouseLeave}
				className={`chat_room_title_banner flex flex-row flex-align-items-center ${classes.toString()}`}
				onClick={bannerClick}
			>
				<div
					onClick={bannerNameClick}
					className={`name ${bannerNameClick ? 'clickable hoverable' : ''}`}>
					{aChatHasNewMentions && !showPersistentChatTabs &&
					<span className='badge has_new_messages other_chats'>!</span>
					}
					<span className='chat-header__hash'>#</span>
					<span className='chat-header__name'>{chatRoom && chatRoom.name}</span>
					{chatRoom?.userlist?.users?.size > 0 &&
					<span className='chat-header__online'>{__n('· %d ONLINE', '· %d ONLINE', chatRoom.userlist.users.size, chatRoom.userlist.users.size)}</span>
					}
				</div>
				{!isMinimized &&
				<div className='chat_options'
				     onMouseEnter={this.chatOptionsMouseEnter}
				     onMouseLeave={this.chatOptionsMouseLeave}
				>
					{!isPinned && !isPopup &&
					<ChatHeaderButton
						title={__('Minimize')}
						onClick={toggleMainChatMinimized}
						tabTip={__('Minimize')}
					>
						<i className='fa fa-window-minimize' />
					</ChatHeaderButton>
					}
					{chatRoom && chatRoom.has_ladder &&
					<ChatHeaderButton
						title={__('Chat Rules')}
						onClick={toggleChatRules}
						tabTip={__('Rules')}
					>
						<i className='fa fa-book' />
					</ChatHeaderButton>
					}
					{chatSidebarToggle &&
					<ChatHeaderButton
						title={__('Toggle Channels')}
						onClick={() => chatSidebarToggle()}
						tabTip={__('Channels')}
					>
						<i className='fa fa-list' />
					</ChatHeaderButton>
					}
					{chatRoom && chatRoom.hasDescription() &&
					<ChatHeaderButton
						title={__('Toggle Pinned Message')}
						onClick={this.descriptionToggle}
						active={chatRoom && chatRoom.descriptionIsActive()}
						tabTip={__('Info')}
					>
						<i className='fa fa-info-circle' />
					</ChatHeaderButton>
					}
					{chatRoom && chatRoom.hasMod(myUser) &&
					<ChatHeaderButton
						title={__('Edit Chat Room Settings')}
						href={chatRoom.getEditUrl()}
						target='_blank'
						tabTip={__('Admin')}
					>
						<i className='fa fa-gears' />
					</ChatHeaderButton>
					}
				</div>
				}
			</div>
		);
	}
}

function ChatHeaderAction({ label, icon, onClick, pressed, href, target }) {
	if(href) {
		return (
			<a className='chat-header-action' href={href} target={target}>
				<i className={`fa ${icon}`} aria-hidden='true' />
				<span className='chat-header-action__label'>{label}</span>
			</a>
		);
	}
	return (
		<button
			type='button'
			className='chat-header-action'
			onClick={onClick}
			aria-pressed={pressed === undefined ? undefined : pressed}
		>
			<i className={`fa ${icon}`} aria-hidden='true' />
			<span className='chat-header-action__label'>{label}</span>
		</button>
	);
}

function ChatHeaderButton(props) { //TODO COMBINE WITH TabButton?
	const ref = useRef(null);
	const wavesClasses = useWavesEffect(ref);
	const { children, className, active, tabTip, ...restOfTheProps } = props;
	const classes = new JqueryClassFaker(className);
	if(active) {
		classes.add('active');
	}
	// With an href it's a real link, so middle-click and the browser's link menu work.
	const Element = restOfTheProps.href ? 'a' : 'div';
	return (
		<Element
			ref={ref}
			className={`chat_option ${wavesClasses.toString()} ${classes.toString()}`}
			{...restOfTheProps}>
			{children}
			{!!tabTip &&
			<div className='tab_tip'>
				{tabTip}
			</div>
			}
		</Element>
	);
}